import { Box } from '../box/Box';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import useResponsiveCollapse from '../../../helpers/hooks/useResponsiveCollapse';
import { withProviders } from '../../../providers/with-providers';
import styles from './Summary.module.css';
import { SummaryProps } from './Summary.model';
import { SummaryTrips } from './components/summary-trips/SummaryTrips';
import { SummaryAccordion, SummaryItem } from './components';
import { SummaryItems } from './components/summary-items/SummaryItems';

const Component = (props: SummaryProps) => {
	const [isCollapsed] = useResponsiveCollapse({
		overThresholdCollapsed: props.collapsed ?? false,
		underThresholdCollapsed: props.collapsed ?? true
	});
	if (isCollapsed) return <SummaryCollapsed {...props}></SummaryCollapsed>;
	return <SummaryDefault {...props}></SummaryDefault>;
};

const SummaryCollapsed = (props: SummaryProps) => {
	const { t } = useTranslation('summary');
	const { trips, isMultiTrip, title } = props;
	return (
		<Box className={clsx(styles.summary_collapsed, styles.summary_back)}>
			{/* TITLE */}
			<SummaryItem title={title ?? t('SUMMARY_TITLE')}></SummaryItem>
			{/* TRIPS COLLAPSED */}
			<SummaryTrips isMultiTrip={isMultiTrip} trips={trips} collapsed={true} />
			{/* ACCORDION ITEMS  & TOTAL */}
			<Box className={styles.summary_accordion}>
				<SummaryAccordion
					textShow={t('FLIGHT_DETAILS_CLOSED')}
					textHide={t('FLIGHT_DETAILS_OPENED')}
					triggerPosition="top"
				>
					<Box className={styles.summary}>
						<SummaryItems {...props}></SummaryItems>
					</Box>
				</SummaryAccordion>
			</Box>
		</Box>
	);
};

const SummaryDefault = (props: SummaryProps) => {
	const { t } = useTranslation('summary');
	return (
		<Box className={clsx(styles.summary, styles.summary_back)}>
			<SummaryItem title={props.title ?? t('SUMMARY_TITLE')}></SummaryItem>
			<SummaryItems {...props}></SummaryItems>
		</Box>
	);
};

Component.displayName = 'Summary';
export const Summary = withProviders(Component);
